document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.ifr-toggle');
  const menu = document.querySelector('.ifr-menu');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = menu.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
      menu.classList.remove('open');
      toggle.setAttribute('aria-expanded','false');
    }));
  }
  const items = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach(e => {
      if(e.isIntersecting){ e.target.classList.add('visible'); io.unobserve(e.target); }
    }), {threshold:.12});
    items.forEach(i => io.observe(i));
  } else { items.forEach(i => i.classList.add('visible')); }
});

/* Premium cart controls: AJAX quantity changes with native Shopify checkout fallback. */
document.addEventListener('DOMContentLoaded', () => {
  const cartRoot = document.querySelector('[data-ifr-cart]');
  if (!cartRoot) return;
  const status = document.querySelector('#ifr-cart-status');
  const threshold = Number(cartRoot.dataset.freeShippingThreshold || 7500);
  const money = cents => new Intl.NumberFormat('en-US', {style:'currency', currency:'USD'}).format(cents / 100);
  let busy = false;
  const setBusy = value => {
    busy = value;
    cartRoot.querySelectorAll('[data-quantity-change],[data-cart-remove],#ifr-cart-update').forEach(el => el.disabled = value);
    if (status && value) status.textContent = 'Updating your cart…';
  };
  const renderCart = cart => {
    if (!cart.item_count) { window.location.reload(); return; }
    if (cart.items.length !== cartRoot.querySelectorAll('[data-cart-line]').length) { window.location.reload(); return; }
    cart.items.forEach((item, index) => {
      const row = cartRoot.querySelector(`[data-cart-line="${index + 1}"]`);
      if (!row) return;
      const input = row.querySelector('.ifr-cart-qty');
      const total = row.querySelector('[data-line-total]');
      if (input) input.value = item.quantity;
      if (total) total.textContent = money(item.final_line_price);
    });
    document.querySelectorAll('[data-cart-subtotal],[data-checkout-total]').forEach(el => el.textContent = money(cart.total_price));
    const remaining = Math.max(threshold - cart.total_price, 0);
    const message = document.querySelector('[data-shipping-message]');
    const bar = document.querySelector('[data-shipping-bar]');
    const banner = document.querySelector('[data-shipping-banner]');
    if (message) message.textContent = remaining ? `You’re ${money(remaining)} away from free U.S. shipping.` : 'Free U.S. shipping unlocked.';
    if (bar) bar.style.width = `${Math.min((cart.total_price / threshold) * 100, 100)}%`;
    if (banner) banner.textContent = remaining ? `ADD ${money(remaining)} MORE FOR FREE U.S. SHIPPING` : 'FREE U.S. SHIPPING UNLOCKED';
    document.querySelectorAll('.ifr-cart-link').forEach(cartLink => {
      const count = cartLink.querySelector('.ifr-cart-count');
      if (count) count.textContent = cart.item_count;
    });
    if (status) status.textContent = 'Cart updated.';
  };
  const changeLine = async (line, quantity) => {
    if (busy) return;
    setBusy(true);
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(`${root}cart/change.js`, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({line, quantity})});
      if (!response.ok) throw new Error('Cart update failed');
      renderCart(await response.json());
    } catch (error) {
      if (status) status.textContent = 'The cart could not update automatically. Use Update Cart to continue.';
    } finally { setBusy(false); }
  };
  cartRoot.addEventListener('click', event => {
    const button = event.target.closest('[data-quantity-change],[data-cart-remove]');
    if (!button) return;
    const row = button.closest('[data-cart-line]');
    const input = row && row.querySelector('.ifr-cart-qty');
    if (!row || !input) return;
    const next = button.hasAttribute('data-cart-remove') ? 0 : Math.max(0, Number(input.value) + Number(button.dataset.quantityChange));
    changeLine(Number(row.dataset.cartLine), next);
  });
  cartRoot.addEventListener('change', event => {
    if (!event.target.matches('.ifr-cart-qty')) return;
    const row = event.target.closest('[data-cart-line]');
    changeLine(Number(row.dataset.cartLine), Math.max(0, Number(event.target.value) || 0));
  });
});
